declare var swal: any;
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../services/spinner.service';
import { AppData } from '../../../models/appdata';
import { ApiResponseModel } from '../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';


import { ActorService } from '../../../services/actor.service';
import { DBOperation } from '../../../enums/enum';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { HCPService } from '../../../services/hcp.service';
import { ActorEducationInfoRequest, ActorEducationInfoController, ServiceBranchMapByFormattedCodeRequest } from '../../../models/profileinfo/profileinfo.model';
//import { NgbEducationInfoModal } from '../../educationinfo/modals/educationinfo.modal';
//import { NgbActorDocsModal } from '../../modals/actordocs/actordocs.modal';
//import * as moment from 'moment';
import { CustomDateTimeService } from '../../../services/datetime.service';


import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import {
  ShiftAllocPatternRequest, CareUnitInfoRequest, ParentCareUnitsInfoController, CareUnitByParentCodeInfoController, ShiftTypeInfoRequest,
  ShiftTypeInfoController, StaffTypeInfoRequest, StaffTypeInfoController, MasterH2RContractAddRequest, MasterH2RContractGetRequest, MasterH2RContractController
} from '../../../models/hcare/hcare.model';
import { HcareService } from '../../../services/hcare.service';
import { FaciliesInfoByTypeController, FacilitiesInfoByTypeRequest, ServiceCategoriesController, ServiceCategoriesRequest, ServicesByCategoryCodeController, ServicesByCategoryCodeRequest, ServiceDetailsByCodeRequest, ServiceDetailsByCodeController, TestsByLabCodeController, TestsByLabCodeRequest, LabDepartmentsListController, LabDepartmentsListRequest } from '../../../models/actor/actor';

//import { NgbAddServiceModal } from './view-general/modal/addservice.modal';
//import { NgbAddCategoryModal } from './modals/addcategory.modal';
//import { NgbEditCategoryModal } from './modals/editcategory.modal';
import { NgbAddTestsModal } from './modals/addtests.modal';
//import { Pipe } from '@angular/core';
//import { Injectable } from '@angular/core';
//import { PipeTransform } from '@angular/core';
//import { ServiceCategoryPipe } from '../../../pipes/actors/actorIdentity.pipes';



//@Pipe({
//  name: 'serviceconfigurationpipe2'
//})

//@Injectable()
//export class ServiceConfigurationInfoPipe2 implements PipeTransform {

//  transform(value: ServicesByCategoryCodeController[], filter2: string): ServicesByCategoryCodeController[] {
//    filter2 = filter2 ? filter2.toLocaleLowerCase() : null;
//    return filter2 ? value.filter((app: ServicesByCategoryCodeController) =>
//      app.Code != null && app.Code.toString().toLocaleLowerCase().indexOf(filter2) !=-1||
//      app.ServiceName != null && app.ServiceName.toLocaleLowerCase().indexOf(filter2) != -1


//    ) : value;
//  }

//}

@Component({
  selector: 'labsetup',
  templateUrl: './labsetup.component.html',
  styleUrls: ['./labsetup.component.scss']
})

export class  LabsetupComponent implements OnInit {
  @Input() ActorCode: number;
  @Input() ActorType: number;

  @Input() CanEdit: number;
  @Input() CanShow: number;
  searchTitle: string;

  CurrentActorEducationInfoRequest: ActorEducationInfoRequest;
  CurrentActorEducationInfoController: ActorEducationInfoController[];
  CurrentServiceDetailsByCodeRequest: ServiceDetailsByCodeRequest;
  CurrentServiceDetailsByCodeController: ServiceDetailsByCodeController[];
  //
  CurrentActorEditEducationInfoRequest: ActorEducationInfoRequest;
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;

  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public ShowService: boolean = true;
  public ShowServiceDetails: boolean = false; 
  public SelectedCategory: boolean = false;
  public SelectedService: boolean = false;
  //public ShowData: boolean = true;
  public ShowIcon: boolean = false;
  public RequestedPositions: number = 100;

  public MaxDateV = new Date();
  public CanAdjustgetTimezoneOffset: boolean;
  public MinDateV = new Date();

  CurrentLabDepartmentsListController: LabDepartmentsListController[];
  CurrentLabDepartmentsListRequest: LabDepartmentsListRequest;

  LoadDepList() {
    this.CurrentLabDepartmentsListRequest = new LabDepartmentsListRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentLabDepartmentsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.pdata = this.CurrentLabDepartmentsListController;
    this.GetLabDepartmentsListController();
  }

  GetLabDepartmentsListController() {
    this.StartRefreshing();
    //this.spinner.show();
    this.CurrentLabDepartmentsListRequest.ConditionalOperator = 10;
    this.CurrentLabDepartmentsListRequest.FacilityCode = 1;
    //this.CurrentTestsByLabCodeRequest.EffectiveOrderDate = new Date('2016-05-02');    
    //this.CurrentLabOrdersListRequest.OrderTestCode = 10044;
    this.actorservice.GetLabDepartmentsListController(this.CurrentLabDepartmentsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentLabDepartmentsListController = this.ApiResData.Result;
          this.pdata = this.CurrentLabDepartmentsListController;
          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  pdata: any[];

  CurrentTestsByLabCodeController: TestsByLabCodeController[];
  CurrentTestsByLabCodeRequest: TestsByLabCodeRequest;

  LoadTestsByLab() {
    this.CurrentTestsByLabCodeRequest = new TestsByLabCodeRequest();
    this.CurrentTestsByLabCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    if (this.SelectedlabDetails) {
      this.CurrentTestsByLabCodeRequest.LabCode = this.SelectedlabDetails.ServiceCategoryCode || (this.SelectedlabDetails as any).serviceCategoryCode || (this.SelectedlabDetails as any).Code || (this.SelectedlabDetails as any).code || 0;
    }
    this.GetTestsByLabCodeController();
  }

  GetTestsByLabCodeController() {
    this.StartRefreshing();
    this.CurrentTestsByLabCodeRequest.ConditionalOperator = 10;
    this.CurrentTestsByLabCodeRequest.FacilityCode = 1;
    if (this.SelectedlabDetails) {
      this.CurrentTestsByLabCodeRequest.LabCode = this.SelectedlabDetails.ServiceCategoryCode || (this.SelectedlabDetails as any).serviceCategoryCode || (this.SelectedlabDetails as any).Code || (this.SelectedlabDetails as any).code || 0;
    }
    this.actorservice.GetTestsByLabCodeController(this.CurrentTestsByLabCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentTestsByLabCodeController = this.ApiResData.Result;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }
      },
        (error) => {
          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }
      );
  }

  SelectedlabDetails: LabDepartmentsListController;

  Selectedlab(objCategory: any) {
    var Labdept: LabDepartmentsListController = objCategory;
    if (Labdept != null) {
      this.SelectedlabDetails = null;
      this.SelectedlabDetails = Labdept;
      this.ShowService = true;
      this.SelectedCategory = true;
      this.SelectedService = false;
      this.ShowIcon = false;
      this.LoadTestsByLab();
      //this.ScanDetails = true;      
      //this.LoadScansData();
      //this.LoadOvaryData();
      //this.LoadTestData();
      //this.LoadMedicineData();
      //this.LoadLmp()
      //this.LoadCycleActivities = true;
      //this.CanLoadReport = true;
      //this.ngOnChanges2(this.changes);
    }

  }

  CurrentServiceCategoriesController: ServiceCategoriesController[];
  CurrentServiceCategoriesRequest: ServiceCategoriesRequest;

  ValidTo: NgbDateStruct;
  ValidFrom: NgbDateStruct;



  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  AddSpecialty: string;

  //AddStaffTypeCode: number;

  //AddShiftTypeCode: number;

 

  LoadRegistries() {
    this.StartRefreshing();


    this.CurrentServiceCategoriesController = new Array<ServiceCategoriesController>();
    
    this.CurrentServiceCategoriesRequest = new ServiceCategoriesRequest();
    this.CurrentServiceCategoriesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.CurrentServiceBranchMapByFormattedCodeRequest.FormattedCode = 2; // registries  
    //this.pdata = this.CurrentServiceCategoriesController;
    this.GetServiceCategoriesController();




  }
  SelectedRegistry: FaciliesInfoByTypeController;
  ViewRateContracts(l: any) {

    //alert(l.DisplayName);

    this.SelectedRegistry = l;
    this.LoadContracts();
  }
  GetServiceCategoriesController() {
    this.StartRefreshing();
    this.CurrentServiceCategoriesRequest.ParentCode = -1;
    this.actorservice.GetServiceCategoriesController(this.CurrentServiceCategoriesRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.CurrentServiceCategoriesController = this.ApiResData.Result;
          //this.pdata = this.CurrentServiceCategoriesController;
          //alert(this.CurrentServiceCategoriesController.length);
          this.ShowService = false;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  constructor(private router: Router,
    private hcareservice: HcareService,
    private actorservice: ActorService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService,
    private modalService: NgbModal,private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService) { }


  ngOnInit() {

    this.MinDateV.setFullYear(this.MinDateV.getFullYear() - 80);
    this.maxDate = { year: this.MaxDateV.getFullYear(), month: this.MaxDateV.getMonth() + 1, day: this.MaxDateV.getDate() };
    this.minDate = { year: this.MinDateV.getFullYear(), month: this.MinDateV.getMonth() + 1, day: this.MinDateV.getDate() };

    this.CanAdjustgetTimezoneOffset = AppData.CanAdjustgetTimezoneOffset;
    this.isNew = true;
    this.isEdit = false;
    this.ShowService = false;
    this.CurrentActorEducationInfoRequest = new ActorEducationInfoRequest();
    this.CurrentActorEducationInfoController = new Array<ActorEducationInfoController>();
    this.CurrentActorEducationInfoRequest.ActorCode = this.ActorCode;
    //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
    this.CurrentActorEducationInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentActorEditEducationInfoRequest = new ActorEducationInfoRequest();
    this.CurrentActorEditEducationInfoRequest.ActorCode = this.ActorCode;

    this.CurrentActorEditEducationInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    if (this.CanShow === 1) {
      //this.GetActorEducationInfoController();
    }
    this.LoadMasterData();
    this.LoadDepList();
    this.LoadTestsByLab();
  }

  viewservice1() {
    this.ShowService = true;
    this.SelectedCategory = true;
    this.SelectedService = false;
    this.ShowIcon = false;
  }
  ViewServiceDetails(l?: any) {
    if (l) {
      this.SelectedService = l;
    }
    this.ShowService = false;
    this.SelectedCategory = false;
    this.ShowIcon = true;
  }
  back() {
    this.ShowService = true; 
    this.SelectedCategory = false;
    this.SelectedService = false;
    this.ShowIcon = false;
  }
  addtestmodal() {
    const modalRef = this.modalService.open(NgbAddTestsModal,
      {
        centered: true,
        //size: "lg"
      })
  }

  CurrentShiftTypeInfoRequest: ShiftTypeInfoRequest;
  CurrentShiftTypeInfoController: ShiftTypeInfoController[];

  CurrentStaffTypeInfoRequest: StaffTypeInfoRequest;
  CurrentStaffTypeInfoController: StaffTypeInfoController[];

  LoadMasterData(){

    this.LoadRegistries();
  this.CurrentStaffTypeInfoRequest = new StaffTypeInfoRequest();
  this.CurrentStaffTypeInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  this.CurrentStaffTypeInfoRequest.HospitalActorCode = AppData.Instance().UserLoginDetails.FacilityActorCode;
  this.CurrentStaffTypeInfoController = new Array<StaffTypeInfoController>();

  this.CurrentShiftTypeInfoRequest = new ShiftTypeInfoRequest();
  this.CurrentShiftTypeInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  this.CurrentShiftTypeInfoRequest.HospitalActorCode = AppData.Instance().UserLoginDetails.FacilityActorCode;
  this.CurrentShiftTypeInfoController = new Array<ShiftTypeInfoController>();

    this.GetShiftTypeInfoController();
    this.GetStaffTypeInfoController();
 


  }
  MasterH2RContractGetRequest: MasterH2RContractGetRequest;
  MasterH2RContractController: MasterH2RContractController[];
  public LoadContracts() {

 
    this.MasterH2RContractGetRequest = new MasterH2RContractGetRequest();
    this.MasterH2RContractGetRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.MasterH2RContractGetRequest.HospitalActorCode = AppData.Instance().UserLoginDetails.FacilityActorCode;
    this.MasterH2RContractGetRequest.RegistryActorCode = this.SelectedRegistry.FacilityActorCode;
    this.MasterH2RContractController = new Array<MasterH2RContractController>();
    
    this.GetMasterH2RContractController();
    
 

  }
  GetMasterH2RContractController() {
    this.StartRefreshing();
    this.hcareservice.GetMasterH2RContractController(this.MasterH2RContractGetRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.MasterH2RContractController = this.ApiResData.Result;
          

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
 
  public AddShiftTypeCode: number;

  GetShiftTypeInfoController() {
    this.StartRefreshing();
    this.hcareservice.GetShiftTypeInfoController(this.CurrentShiftTypeInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentShiftTypeInfoController = this.ApiResData.Result;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  //pdata: any[];// = this.data;
  listFilter: string;
  
  
  //SelectedCategory: ServiceCategoriesController;
  //viewservice(objCategory: any) {
  //  var category: ServiceCategoriesController = objCategory;

  //  if (category != null) {
      
  //    this.BackToServices();
  //    this.SelectedCategory = null;
  //    this.SelectedCategory = category;
  //    this.ShowService = true;
  //    //this.ShowData = false;
  //    this.LoadServicesByCategory();
  //  }
  //  else {
  //    this.SelectedCategory = null;
  //    this.ShowService = false;
  //  }

  //}
  ServicesByCategoryCodeGetRequest: ServicesByCategoryCodeRequest;
  ServicesByCategoryCodeController: ServicesByCategoryCodeController[];
  //LoadServicesByCategory() {
    
  //  this.ServicesByCategoryCodeGetRequest = new ServicesByCategoryCodeRequest();
  //  //this.pdata2 = this.ServicesByCategoryCodeController;
  //  this.ServicesByCategoryCodeGetRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.ServicesByCategoryCodeGetRequest.ServiceCategory = this.SelectedCategory.Code.toString();// AppData.Instance().UserLoginDetails.FacilityActorCode;
  
  //  this.ServicesByCategoryCodeController = new Array<ServicesByCategoryCodeController>();
  //  this.GetServicesByCategoryCodeController();

  //}
  GetServicesByCategoryCodeController() {
    this.StartRefreshing();
    this.actorservice.GetServicesByCategoryCodeController(this.ServicesByCategoryCodeGetRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          this.ServicesByCategoryCodeController = this.ApiResData.Result;
          //this.pdata2 = this.ServicesByCategoryCodeController;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  IsSelected(){

  }
  //Addgeneral() {
    
  //  const modalRef = this.modalService.open(NgbAddServiceModal,
  //    {
  //      centered: true,
  //      size: "lg"
  //    })

  //}
  criteriaChange(value: any) {
    
  }
  public AddStaffTypeCode: number;
  GetStaffTypeInfoController() {
    this.StartRefreshing();
    this.hcareservice.GetStaffTypeInfoController(this.CurrentStaffTypeInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentStaffTypeInfoController = this.ApiResData.Result;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  clearData2() {
    this.ValidFrom = null;
    this.ValidTo = null;
    this.isNew = true;
    this.isEdit = false;
    //this.CurrentActorEducationInfoRequest = null;
    //this.CurrentActorEducationInfoRequest = new ActorEducationInfoRequest();
    //this.CurrentActorEditEducationInfoRequest.ConditionalOperator = 1;
    //this.CurrentActorEducationInfoRequest.ActorCode = this.ActorCode;
    //this.CurrentActorEducationInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
   

  }
  clearData() {
   
    this.ShowList = false;

  }
  //SelectedService: ServicesByCategoryCodeController;
  //ViewServiceDetails(objCategory: any) {
  //  var service: ServicesByCategoryCodeController = objCategory;

  //  if (service != null) {

  //    //this.router.navigate(['testnurse/serviceconfig']);
  //    this.ShowService = false;
  //    this.SelectedService = service;
  //    this.ShowServiceDetails = true;
  //    this.ShowIcon = true;
  //  }
  //  else {
  //    this.SelectedService = null;
  //    this.ShowService = true;
  //    this.ShowServiceDetails = false;
  //  }
  //}
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }

  public onInputValidFrom(value: Date): void {

    console.log('value-->' + value);

    this.CurrentActorEditEducationInfoRequest.StartFrom = value;
  }
  public onInputValidTo(value: Date): void {

    this.CurrentActorEditEducationInfoRequest.CompletedAt = value;
  }

  GetActorEducationInfoController() {
    this.StartRefreshing();
    this.hcpservice.GetActorEducationInfoController(this.CurrentActorEducationInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentActorEducationInfoController = this.ApiResData.Result;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  onSubmit_() {
   // alert("On Submit");
    if (this.ShowList) {

      return;
    }
    else {
    //  alert("not showing list, proceed to savve...");
    }
    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorEducationInfoRequest.ConditionalOperator = 1;
    //if (this.CanAdjustgetTimezoneOffset === true) {
    //  this.CurrentActorEducationInfoRequest.StartFrom = this.customdatetimeservice.converToLocalTime(this.CurrentActorEducationInfoRequest.StartFrom);
    //  this.CurrentActorEducationInfoRequest.CompletedAt = this.customdatetimeservice.converToLocalTime(this.CurrentActorEducationInfoRequest.CompletedAt);
    //  //console.log('ssssssssssssssssssssssssssssssss->'+this.CurrentActorEducationInfoRequest.StartFrom);
    //  //console.log('asdddddddddddddddddddd--->' + a);

    //  //this.CurrentActorEducationInfoRequest.StartFrom = a;

    //  //console.log('asdddddddddddddddddddd--->' + this.CurrentActorEducationInfoRequest.StartFrom);

    //  //if (this.CurrentActorEducationInfoRequest.StartFrom != null && this.CurrentActorEducationInfoRequest.StartFrom.getFullYear() > 1990) {
    //  //  this.CurrentActorEducationInfoRequest.StartFrom.setMinutes(this.CurrentActorEducationInfoRequest.StartFrom.getMinutes() + -(this.CurrentActorEducationInfoRequest.StartFrom.getTimezoneOffset()))


    //  //}
    //  //if (this.CurrentActorEducationInfoRequest.CompletedAt != null && this.CurrentActorEducationInfoRequest.CompletedAt.getFullYear() > 1990) {

    //  //  this.CurrentActorEducationInfoRequest.CompletedAt.setMinutes(this.CurrentActorEducationInfoRequest.CompletedAt.getMinutes() + -(this.CurrentActorEducationInfoRequest.CompletedAt.getTimezoneOffset()))

    //  //}

    //}

    if (this.ValidFrom != null) {



      this.CurrentActorEducationInfoRequest.StartFrom = new Date(this.parserFormatter.format(this.ValidFrom));;
    }
    if (this.ValidTo != null) {



      this.CurrentActorEducationInfoRequest.CompletedAt = new Date(this.parserFormatter.format(this.ValidTo));;
    }
   
    this.hcpservice.SaveActorEducationInfo(this.CurrentActorEducationInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorEducationInfoController();
           // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.ShowList = true;
            this.clearData2();


            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }

  ShowList: boolean = true;
  CancelUpdateOperation() {
    //alert("cancell upd op");
    this.ShowList = true;
  }
  CancelNewOperation() {
    //alert("cancell new op");
    this.ShowList = true;
  }
  edit_(EditCurrentActorEducationInfoController: ActorEducationInfoController) {
    this.ShowList = false;
    this.IsExpand = true;
    this.CurrentActorEditEducationInfoRequest.ConditionalOperator = 2;
    this.CurrentActorEditEducationInfoRequest.EducationCode = EditCurrentActorEducationInfoController.EducationCode;
    this.CurrentActorEditEducationInfoRequest.ActorCode = EditCurrentActorEducationInfoController.ActorCode;
    this.CurrentActorEditEducationInfoRequest.InstituteName = EditCurrentActorEducationInfoController.InstituteName;
    this.CurrentActorEditEducationInfoRequest.InstituteType = EditCurrentActorEducationInfoController.InstituteType;
    this.CurrentActorEditEducationInfoRequest.Location = EditCurrentActorEducationInfoController.Location;
    this.CurrentActorEditEducationInfoRequest.CourseStudy = EditCurrentActorEducationInfoController.CourseStudy;
    this.CurrentActorEditEducationInfoRequest.StartFrom = EditCurrentActorEducationInfoController.StartFrom;
    this.CurrentActorEditEducationInfoRequest.CompletedAt = EditCurrentActorEducationInfoController.CompletedAt;


    if (this.CurrentActorEditEducationInfoRequest.StartFrom != null) {
      var SValidFrom = new Date(this.CurrentActorEditEducationInfoRequest.StartFrom);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.ValidFrom >1990');
        this.ValidFrom = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }


    if (this.CurrentActorEditEducationInfoRequest.CompletedAt != null) {
      var SValidTo = new Date(this.CurrentActorEditEducationInfoRequest.CompletedAt);
      if (SValidTo.getFullYear() > 1900) {
        console.log('this.ValidFrom >1990');
        this.ValidTo = {

          year: SValidTo.getFullYear(),
          month: SValidTo.getMonth() + 1,
          day: SValidTo.getDate()
        }
      }
    }



    this.CurrentActorEditEducationInfoRequest.IsGraduate = EditCurrentActorEducationInfoController.IsGraduate;
    this.CurrentActorEditEducationInfoRequest.CourseType = EditCurrentActorEducationInfoController.CourseType;

    this.CurrentActorEditEducationInfoRequest.Subjects = EditCurrentActorEducationInfoController.Subjects;
    this.CurrentActorEditEducationInfoRequest.Remarks = EditCurrentActorEducationInfoController.Remarks;
   

    this.isNew = false;
    this.isEdit = true;


  }
  //BackToServices() {
  //  this.ShowService = true;
  //  this.ShowServiceDetails = false;

  //}
  //RadioAssignChange(value: any) {

  //  //alert(value);
  //  var selected: any = value;
    
  //  var ind: number = 0;
   
     
  //    ind++;
  //  }
  //RadioAssignChange(value: any) {

    
  //  var selected: ServicesByCategoryCodeController = value;
    
  //  var ind: number = 0;
  //  while (ind < this.Commission.length) {
  //    if (selected != this.Commission[ind]) {
  //      this.Commission[ind].IsSelected = false;

  //    }
  //    else {


  //    }
  //    ind++;
  //  }

  //}
  
  onEditSubmit() {

   // alert("On edit Submit");
    if (this.ShowList)
      return;
    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorEditEducationInfoRequest.ConditionalOperator = 2;
    //console.log('this.CurrentActorEditEducationInfoRequest.StartFrom...>' + this.CurrentActorEditEducationInfoRequest.StartFrom);
    //console.log('this.CurrentActorEditEducationInfoRequest.CompletedAt...>' + this.CurrentActorEditEducationInfoRequest.CompletedAt);

    //var a = this.converToLocalTime(this.CurrentActorEditEducationInfoRequest.StartFrom);
    //console.log('a----------------------->'+a);
    //if (this.CanAdjustgetTimezoneOffset === true) {
    //  this.CurrentActorEditEducationInfoRequest.StartFrom = this.customdatetimeservice.converToLocalTime(this.CurrentActorEditEducationInfoRequest.StartFrom);
    //  this.CurrentActorEditEducationInfoRequest.CompletedAt = this.customdatetimeservice.converToLocalTime(this.CurrentActorEditEducationInfoRequest.CompletedAt);
    //  //this.CurrentActorEditEducationInfoRequest.StartFrom = new Date(this.CurrentActorEditEducationInfoRequest.StartFrom);

    //  //this.CurrentActorEditEducationInfoRequest.CompletedAt = new Date(this.CurrentActorEditEducationInfoRequest.CompletedAt);


    //  //if (this.CurrentActorEditEducationInfoRequest.StartFrom != null && this.CurrentActorEditEducationInfoRequest.StartFrom.getFullYear() > 1990) {
    //  //  console.log('this.CurrentActorEditEducationInfoRequest.StartFrom...>' + this.CurrentActorEditEducationInfoRequest.StartFrom);

    //  //  this.CurrentActorEditEducationInfoRequest.StartFrom.setMinutes(this.CurrentActorEditEducationInfoRequest.StartFrom.getMinutes() + -(this.CurrentActorEditEducationInfoRequest.StartFrom.getTimezoneOffset()))

    //  //  console.log('this.CurrentActorEditEducationInfoRequest.StartFrom...>' + this.CurrentActorEditEducationInfoRequest.StartFrom);


    //  //}
    //  //if (this.CurrentActorEditEducationInfoRequest.CompletedAt != null && this.CurrentActorEditEducationInfoRequest.CompletedAt.getFullYear() > 1990) {

    //  //  this.CurrentActorEditEducationInfoRequest.CompletedAt.setMinutes(this.CurrentActorEditEducationInfoRequest.CompletedAt.getMinutes() + -(this.CurrentActorEditEducationInfoRequest.CompletedAt.getTimezoneOffset()))

    //  //}

    //}



    if (this.ValidFrom != null) {



      this.CurrentActorEditEducationInfoRequest.StartFrom = new Date(this.parserFormatter.format(this.ValidFrom));;
    }
    if (this.ValidTo != null) {



      this.CurrentActorEditEducationInfoRequest.CompletedAt = new Date(this.parserFormatter.format(this.ValidTo));;
    }

    this.hcpservice.SaveActorEducationInfo(this.CurrentActorEditEducationInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorEducationInfoController();
            //alertFunctions.AlertParam('Update Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Updated Successfully.....!');
            this.ShowList = true;
            this.clearData2();


            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }

  BackToServices() {
    this.SelectedService = null;
    this.ShowService = true;
    this.ShowServiceDetails = false;
    this.ShowIcon = false;
  }
  gotoservice() {
    this.router.navigate(['nurse/serviceconfig']);
  }



  del_(EducationCode: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentities(EducationCode);
     // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  //AddService() {
  //  const modalRef = this.modalService.open(NgbAddServiceModal,
  //    {
  //      centered: true,
  //      size: "lg"
  //    })

  //}
  DeleteActorIdentities(EducationCode: any) {


    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorEducationInfoRequest.ConditionalOperator = 3;
    this.CurrentActorEducationInfoRequest.EducationCode = EducationCode;
    this.hcpservice.SaveActorEducationInfo(this.CurrentActorEducationInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            this.ShowList = true;


            this.stopRefreshing();
            this.GetActorEducationInfoController();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }
  //maxDate: NgbDateStruct;
  //minDate: NgbDateStruct;

  AddRequest: MasterH2RContractAddRequest;
  AddNewOperation() {
    this.StartRefreshing();

    var shifts = this.CurrentShiftTypeInfoController.filter(x => x.ShiftTypeCode == this.AddRequest.PreferedShiftTypeCode);
    this.AddRequest.PreferedShiftType = shifts[0].Name; // ShiftDeail 

    var roles = this.CurrentStaffTypeInfoController.filter(x => x.StaffTypeCode == this.AddRequest.StaffTypeCode);
    this.AddRequest.StaffType = roles[0].Name;
    this.AddRequest.Remarks = "Resource Added Directly by Hospital";
    //alert(this.AddRequest.Remarks);


    this.AddRequest.RegistryActorCode = this.SelectedRegistry.FacilityActorCode;
    this.AddRequest.FromDate = new Date();
    this.AddRequest.ToDate = new Date();
    this.AddRequest.R2NPayRate = this.AddRequest.PayRate;



    
    this.hcareservice.SaveMasterH2RContract(this.AddRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.clearData2();

            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.ShowList = true;


            this.stopRefreshing();
            this.GetMasterH2RContractController();
            //this.GetActorEducationInfoController();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!" + this.ApiResData.ResultDescription);
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }

  
  openDocContent(ActorDocCode: any) {
    if (ActorDocCode > 0) {
      let options: NgbModalOptions = {
        size: 'lg'
      };
      //const modalRef = this.modalService.open(NgbActorDocsModal, options)//.result(result => { this.GetActorProfileController();});
      //modalRef.componentInstance.ActorDocCode = ActorDocCode;
      //modalRef.componentInstance.CanEdit = this.CanEdit;
      //modalRef.componentInstance.CanShow = this.CanShow;
     
    }
    else {
      alertFunctions.AlertParam('No permission to Upload Doc For this Record...!');
    }
  }



  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }



   converToLocalTime(serverDate) :Date{
     if (serverDate != null) {
       var dt = new Date(Date.parse(serverDate));
       var localDate = dt;

       var gmt = localDate;
       var min = gmt.getTime() / 1000 / 60; // convert gmt date to minutes
       var localNow = new Date().getTimezoneOffset(); // get the timezone
       // offset in minutes
       var localTime = min - localNow; // get the local time

       var dateStr = new Date(localTime * 1000 * 60);
       // dateStr = dateStr.toISOString("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"); // this will return as just the server date format i.e., yyyy-MM-dd'T'HH:mm:ss.SSS'Z'
       //dateStr = dateStr.toString("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");

       console.log('dateStr-------------' + dateStr);
       console.log('dateStr.toISOString-------------' + dateStr.toISOString());
       console.log('dateStr.toISOString to date-------------' + new Date(dateStr.toISOString()));
       return dateStr;
     }
     else {
       return null;
     }
   }
  //AddCategory() {
  //  const modalRef = this.modalService.open(NgbAddCategoryModal,
  //    {
  //      centered: true,
        
  //    })
  //}
  //EditCategory() {
  //  const modalRef = this.modalService.open(NgbEditCategoryModal,
  //    {
  //      centered: true,
      
  //    })
  //}
}
